/**
 * Regex pattern matching common zero-width and invisible Unicode characters.
 * Includes: Zero Width Space, Zero Width Non-Joiner, Zero Width Joiner,
 * Zero Width No-Break Space (BOM), Left-to-Right Mark, Right-to-Left Mark.
 */
const ZERO_WIDTH_CHARS_REGEX = /[\u200B\u200C\u200D\uFEFF\u200E\u200F]/g;
export const removeZeroWidthChars = (str) => {
    return str ? str.replace(ZERO_WIDTH_CHARS_REGEX, '') : str;
};
